class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.initHoverOpen();
  }

  // Open the submenu on mouse hover (desktop pointers only); touch and keyboard keep click behavior.
  initHoverOpen() {
    this.hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.hoverCloseDelay = 200;
    this.summary = this.mainDetailsToggle.querySelector('summary');

    this.mainDetailsToggle.addEventListener('pointerenter', (event) => {
      if (!this.isHoverPointer(event)) return;
      clearTimeout(this.hoverCloseTimer);
      this.closeSiblingMenus();
      this.open();
    });

    this.mainDetailsToggle.addEventListener('pointerleave', (event) => {
      if (!this.isHoverPointer(event)) return;
      clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = setTimeout(() => this.close(), this.hoverCloseDelay);
    });

    // A mouse click on an already hover-opened summary would otherwise close the menu.
    this.summary.addEventListener('click', (event) => {
      if (this.hoverMedia.matches && event.pointerType === 'mouse' && this.mainDetailsToggle.open) {
        event.preventDefault();
      }
    });
  }

  // Close other open menus immediately so two submenus never overlap during fast hovering.
  closeSiblingMenus() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu === this) return;
      clearTimeout(menu.hoverCloseTimer);
      if (menu.mainDetailsToggle?.open) menu.close();
    });
  }

  isHoverPointer(event) {
    return event.pointerType === 'mouse' && this.hoverMedia.matches;
  }

  open() {
    if (this.mainDetailsToggle.open) return;
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
